import { MyLearningService } from "@/services";
import { useQuery } from "@tanstack/react-query"


export const useMyLearningStats = () => {
    const {
        data: stats, 
        isFetching,
        isError,
        error,
    } = useQuery({
        queryKey: ["my-learning-stats"],
        queryFn: ({ signal }) => 
            MyLearningService.getStats(signal),
        staleTime: 60 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
    });

    return {
        stats: stats ?? {
            progressPercentage: 0,
            completedCoursesCount: 0,
            inProgressCoursesCount: 0,
            totalTimeViewedMinutes: 0,
        },
        isLoading: isFetching,
        isError,
        error,
    };
};

